import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

export const fetchTemples = createAsyncThunk(
  "temples/fetchTemples",
  async () => {
    const res = await fetch("https://api.washim.org/api/temples");
    return res.json();
  }
);

export const fetchTempleById = createAsyncThunk(
  "temples/fetchTempleById",
  async (id) => {
    const res = await fetch(
      `https://api.washim.org/api/temples/${id}`
    );
    return res.json();
  }
);

const templeSlice = createSlice({

  name: "temples",

  initialState: {
    temples: [],
    temple: null,
    loading: false
  },

  reducers: {},

  extraReducers: (builder) => {

    builder.addCase(fetchTemples.pending, (state) => {
      state.loading = true;
    });

    builder.addCase(fetchTemples.fulfilled, (state, action) => {
      state.temples = action.payload;
      state.loading = false;
    });

    builder.addCase(fetchTempleById.fulfilled, (state, action) => {
      state.temple = action.payload;
    });

  }

});

export default templeSlice.reducer;